var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPriceOverride(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 32 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "price-override-a",
    d: "M2.716.143h52a2 2 0 0 1 2 2v52a2 2 0 0 1-2 2h-52a2 2 0 0 1-2-2v-52a2 2 0 0 1 2-2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "price-override-c",
    d: "M22.05 0c5.048 0 9.144 4.096 9.144 9.143 0 5.047-4.096 9.143-9.143 9.143a9.104 9.104 0 0 1-5.793-2.07 9.905 9.905 0 0 0 1.192-1.394 7.269 7.269 0 0 0 4.6 1.635c4.033 0 7.315-3.282 7.315-7.314s-3.282-7.314-7.314-7.314a7.28 7.28 0 0 0-4.602 1.633 9.887 9.887 0 0 0-1.19-1.392A9.103 9.103 0 0 1 22.05 0zm.284 8.357c-1.618-.412-2.14-.86-2.14-1.527 0-.768.723-1.308 1.92-1.308 1.263 0 1.738.604 1.775 1.5h1.563c-.046-1.225-.795-2.35-2.277-2.716V2.743h-2.13v1.545c-1.38.293-2.487 1.189-2.487 2.57 0 1.636 1.363 2.459 3.347 2.934 1.782.42 2.139 1.051 2.139 1.71 0 .484-.357 1.27-1.92 1.27-1.463 0-2.039-.658-2.121-1.499H18.43c.092 1.554 1.244 2.432 2.615 2.716v1.554h2.14v-1.527c1.39-.265 2.486-1.06 2.496-2.533-.01-2.011-1.738-2.706-3.347-3.126z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "price-override-d",
    d: "M9.143 0C4.096 0 0 4.096 0 9.143c0 5.047 4.096 9.143 9.143 9.143 5.047 0 9.143-4.096 9.143-9.143C18.286 4.096 14.19 0 9.143 0zm0 16.457c-4.032 0-7.314-3.282-7.314-7.314S5.11 1.829 9.143 1.829s7.314 3.282 7.314 7.314-3.282 7.314-7.314 7.314zm.283-8.1c-1.618-.412-2.14-.86-2.14-1.527 0-.768.723-1.308 1.92-1.308 1.263 0 1.738.604 1.775 1.5h1.563c-.046-1.225-.795-2.35-2.277-2.716V2.743h-2.13v1.545c-1.38.293-2.487 1.189-2.487 2.57 0 1.636 1.363 2.459 3.347 2.934 1.782.42 2.139 1.051 2.139 1.71 0 .484-.357 1.27-1.92 1.27-1.463 0-2.039-.658-2.121-1.499H5.522c.092 1.554 1.244 2.432 2.615 2.716v1.554h2.14v-1.527c1.39-.265 2.486-1.06 2.496-2.533-.01-2.011-1.738-2.706-3.347-3.126z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-12 -17.926)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "price-override-b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#price-override-a"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#E5E5E5",
    d: "M2.716.643a1.5 1.5 0 0 0-1.5 1.5v52a1.5 1.5 0 0 0 1.5 1.5h52a1.5 1.5 0 0 0 1.5-1.5v-52a1.5 1.5 0 0 0-1.5-1.5h-52z"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#price-override-b)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#747474",
    fillRule: "nonzero",
    transform: "translate(12.716 18.643)"
  }, /*#__PURE__*/React.createElement("use", {
    opacity: 0.475,
    xlinkHref: "#price-override-c"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#price-override-d"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceOverride);
export default __webpack_public_path__ + "static/media/PriceOverride.a0959bbd.svg";
export { ForwardRef as ReactComponent };